import type { ReactElement } from 'react'
import styled from 'styled-components'

import { BSTable, CFTable, PLTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { AnotationText } from '@/components/enlayouts/Ir/Mpocket/AnotationText'
import { DownloadButton } from '@/components/enlayouts/Ir/Mpocket/DownloadButton'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const CfsPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-financial-cfs_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-financial-cfs_en.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Consoliated Financial Statements"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>Download (Consolidated PL, BS, CF)</AHeading>
        <Download>
          <DownloadButton id="irp-cfs-pdf_en" />
          <DownloadButton id="irp-cfs-xls_en" />
        </Download>
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>Consolidated Profit and Loss Statement</AHeading>
        <PLTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-pltxt_en" />
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>Consolidated Balance Sheets</AHeading>
        <BSTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-bstxt_en" />
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>Consolidated Cashflow Statement</AHeading>
        <CFTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-cftxt_en" />
      </section>
    </Layout>
  )
}

CfsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Financial Information', path: '/en/ir/financial/' },
    { name: 'Consolidated Financial Statements', path: '' },
  ]

  return (
    <>
      <Head
        title="Consolidated Financial Statements"
        description="The consolidated Profit and Loss, Balance Sheet, and Cash Flow statements for our group."
        ogp={{ url: 'en/ir/financial/cfs/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
const Download = styled.div`
  display: flex;
  gap: 20px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    gap: 16px;
  }
`
